// src/pages/Contact/Contact.jsx

import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebook, FaTwitter, FaInstagram, FaUser, FaPaperPlane } from 'react-icons/fa';
import { HiOutlineMail, HiOutlineDeviceMobile, HiOutlineBookOpen } from 'react-icons/hi';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="contact-page">
      <div className="contact-header">
        <div className="container">
          <h1 className="contact-title">Get In Touch</h1>
          <p className="contact-subtitle">
            Have questions or need assistance? Our team is here to help you!
          </p>
        </div>
      </div>

      <div className="con">
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-section">
              <div className="info-icon">
                <FaClock className="icon" />
              </div>
              <div className="info-content">
                <h3 className="info-title">Customer Service</h3>
                <p className="info-text">
                  Monday - Friday: 9am-6pm EST<br />
                  Saturday: 10am-4pm EST
                </p>
              </div>
            </div>

           {/* <div className="info-section">
              <div className="info-icon">
                <FaPhone className="icon" />
              </div>
              <div className="info-content">
                <h3 className="info-title">Phone</h3>
                <p className="info-text">
                  <a href="tel:+491632055734" className="info-link">+491632055734</a>
                </p>
              </div>
            </div>*/}

            <div className="info-section">
              <div className="info-icon">
                <FaEnvelope className="icon" />
              </div>
              <div className="info-content">
                <h3 className="info-title">Email</h3>
                <p className="info-text">
                  <a href="mailto:support@Infohomelandpharma.com" className="info-link">
                  Infohomelandpharma@gmail.com
                  </a>
                </p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-icon">
                <FaMapMarkerAlt className="icon" />
              </div>
              <div className="info-content">
                <h3 className="info-title">Address</h3>
                <p className="info-text">
                  PrimCare Pharmacy <br />
                  123 Health Street<br />
                  Medical District, MD 12345<br />
                  United States
                </p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-icon">
                <div className="social-icon-container">
                  <FaFacebook className="icon" />
                </div>
              </div>
              <div className="info-content">
                <h3 className="info-title">Follow Us</h3>
                <div className="social-links">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                    <FaFacebook className="social-icon" />
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                    <FaTwitter className="social-icon" />
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                    <FaInstagram className="social-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h2 className="form-title">
              <FaPaperPlane className="title-icon" />
              Send us a message
            </h2>

            {submitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h3>Thank you!</h3>
                <p>Your message has been sent successfully. We'll get back to you soon.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">
                    <FaUser className="input-icon" />
                    Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your full name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">
                    <HiOutlineMail className="input-icon" />
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">
                    <HiOutlineDeviceMobile className="input-icon" />
                    Phone
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="(123) 456-7890"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">
                    <HiOutlineBookOpen className="input-icon" />
                    Subject *
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="What's this about?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Your message here..."
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary submit-btn">
                  <FaPaperPlane className="btn-icon" />
                  SEND MESSAGE
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;